import React from 'react';
import './Input.css';

const Input = ({
  type = 'text',
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  label,
  error,
  touched,
  disabled = false,
  required = false,
  icon,
  iconPosition = 'left',
  className = '',
  ...props
}) => {
  const showError = error && touched;

  return (
    <div className={`input-wrapper ${className} ${showError ? 'has-error' : ''}`}>
      {label && (
        <label className="input-label" htmlFor={name}>
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <div className={`input-container ${icon ? `has-icon icon-${iconPosition}` : ''}`}>
        {icon && <span className="input-icon">{icon}</span>}
        <input
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          className="input-field"
          {...props}
        />
      </div>
      {showError && <span className="input-error">{error}</span>}
    </div>
  );
};

export default Input;
